import type React from "react"
import { Box, Typography, Paper, Avatar } from "@mui/material"
import type { ProfileDto, PropertyInfoDto } from "../../types/message"

interface ConversationHeaderProps {
  participant: ProfileDto | undefined
  propertyInfo?: PropertyInfoDto | null
}

const ConversationHeader: React.FC<ConversationHeaderProps> = ({ participant, propertyInfo }) => {
  if (!participant) return null

  return (
    <Paper elevation={2} sx={{ p: 2, mb: 2, borderRadius: "12px", display: "flex", alignItems: "center" }}>
      <Avatar
        src={participant.profileImage || "/assets/images/profilePicture.png"}
        alt={participant.fullName}
        sx={{ width: 40, height: 40, mr: 2 }}
      />
      <Box>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          {participant.fullName}
        </Typography>
        {propertyInfo && (
          <Typography variant="caption" color="text.secondary">
            {propertyInfo.title}
          </Typography>
        )}
      </Box>
    </Paper>
  )
}

export default ConversationHeader
